import React from "react";
import { useLocation, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Seo from "../components/Seo";
import Dimension from "../components/Dimension";
import PageHead from "../components/PageHead";
import { LT_BRAND, LT_ROUTES } from "../data";

function NotFound() {
  const { t } = useTranslation();
  const location = useLocation();
  const requested = location.pathname + (location.search || "");

  return (
    <div className="container">
      <Seo page="notFound" path={location.pathname} noindex />

      <PageHead
        title={t("notFound.title")}
        lede={
          <>
            {t("notFound.requested")}{" "}
            <span className="nf-path">{requested}</span>
          </>
        }
      />

      <div className="band">
        <Dimension label={t("dimension.routes", { n: LT_ROUTES.length })} />
      </div>

      <table className="schedule schedule-routes">
        <thead>
          <tr>
            <th>{t("notFound.colRoute")}</th>
            <th>{t("notFound.colSheet")}</th>
          </tr>
        </thead>
        <tbody>
          {LT_ROUTES.map((r) => (
            <tr key={r.to} className="linked">
              <td className="c-name">
                <Link to={r.to}>{r.to}</Link>
              </td>
              <td className="c-desc">{t(r.key)}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="btn-row band">
        <Link className="btn btn-solid" to="/">
          {t("notFound.ctaHome")}
        </Link>
        <a className="btn" href={`mailto:${LT_BRAND.contactEmail}`}>
          {t("notFound.ctaEmail")}
        </a>
      </div>
      <div className="band-bottom" />
    </div>
  );
}

export default NotFound;
